const through = require('through')

const getCreds = require('airship/modules/request2/utils/keymaster')
const normalizeHeaders = require('airship/modules/request2/utils/normalize-headers')

module.exports = addKeymaster

function addKeymaster() {
  return through(function(reqData) {
    const self = this

    // If there's no `authUrl` in the request options, it must not need
    // KM authentication.
    if (!reqData.authUrl) {
      self.queue(reqData)
      return
    }

    const authPath = reqData.authUrl
    reqData.headers = normalizeHeaders(reqData.headers || {})

    // If the user already provided the header, they must know better than we
    // do. Queue it & carry on.
    if (reqData.headers.hasOwnProperty('x-ua-keymaster-digest')) {
      self.queue(reqData)
      return
    }

    getCreds(authPath)
      .then(headers => {
        // Update the headers to include the Keymaster headers.
        Object.assign(reqData.headers, normalizeHeaders(headers))
        self.queue(reqData)
      })
      .catch(err => {
        self.emit('error', err)
      })
  })
}
